var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNabaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 921 314",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 920.919,
    height: 313.137
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.415,254.191l-6.516,0l-0,-182.976l38.315,-0l133.454,173.332l-0,-173.332l6.516,-0l-0,182.976l-41.704,0l-130.065,-167.598l0,167.598Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.52,254.191l81.323,-182.976l39.619,-0l79.759,182.976l-39.619,0l-27.629,-63.598l-0.782,-0c0.695,3.649 1.043,7.559 1.043,11.729c-0,10.947 -2.737,20.331 -8.211,28.15c-5.474,7.82 -12.728,13.728 -21.764,17.725c-9.036,3.996 -18.767,5.994 -29.193,5.994l-74.546,0Zm72.721,-5.734c9.731,0 18.811,-1.824 27.238,-5.474c8.428,-3.649 15.248,-9.253 20.461,-16.811c5.213,-7.559 7.82,-16.986 7.82,-28.281c-0,-12.338 -3.389,-26.413 -10.166,-42.226l-32.842,-75.588c-12.511,27.976 -22.372,56.865 -29.583,86.666c-7.212,29.801 -11.339,57.039 -12.381,81.714l29.453,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.466,254.191l0,-182.976l104,-0c11.99,-0 22.068,2.172 30.235,6.516c8.168,4.344 14.163,10.035 17.985,17.073c3.823,7.037 5.735,14.553 5.735,22.546c-0,6.255 -1.26,12.337 -3.78,18.245c-2.519,5.908 -6.212,10.904 -11.077,14.988c-4.866,4.083 -10.6,6.473 -17.203,7.168c12.685,1.564 22.372,6.473 29.062,14.726c6.69,8.254 10.035,18.029 10.035,29.324c0,8.862 -2.128,17.29 -6.386,25.283c-4.257,7.993 -10.556,14.509 -18.897,19.549c-8.341,5.039 -18.419,7.558 -30.235,7.558l-109.474,0Zm39.098,-57.343c4.344,-15.117 11.034,-25.934 20.07,-32.451c9.036,-6.516 19.201,-9.774 30.496,-9.774l3.128,-0c18.246,-0 27.368,-12.772 27.368,-38.316c0,-11.295 -3.301,-20.548 -9.904,-27.759c-6.604,-7.211 -16.682,-10.817 -30.236,-10.817l-40.922,-0l-0,119.117Zm43.268,50.827c13.728,0 24.545,-4.257 32.451,-12.772c7.906,-8.514 11.86,-20.417 11.86,-35.709c-0,-10.6 -2.911,-19.592 -8.732,-26.977c-5.821,-7.385 -14.032,-11.078 -24.632,-11.078l-3.388,0c-32.147,0 -49.089,28.846 -50.827,86.536l43.268,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.278,254.191l81.323,-182.976l39.619,-0l79.759,182.976l-39.619,0l-27.629,-63.598l-0.782,-0c0.695,3.649 1.043,7.559 1.043,11.729c-0,10.947 -2.737,20.331 -8.211,28.15c-5.474,7.82 -12.728,13.728 -21.764,17.725c-9.036,3.996 -18.767,5.994 -29.193,5.994l-74.546,0Zm72.721,-5.734c9.731,0 18.811,-1.824 27.238,-5.474c8.428,-3.649 15.248,-9.253 20.461,-16.811c5.213,-7.559 7.82,-16.986 7.82,-28.281c-0,-12.338 -3.388,-26.413 -10.165,-42.226l-32.842,-75.588c-12.512,27.976 -22.373,56.865 -29.584,86.666c-7.212,29.801 -11.339,57.039 -12.381,81.714l29.453,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNabaLogo);
export default __webpack_public_path__ + "static/media/naba-logo.d356bf3c7b07a03a580dcd0d6d6579d5.svg";
export { ForwardRef as ReactComponent };